export default __webpack_public_path__ + "static/media/g_wdt_c_2.92131ed9.mp3";